import { useEffect, useState } from "react";
import style from "./../../ClientBook.module.scss";
import StepSkeleton from "../StepSkeleton";
import moment from "moment";

const BookingConfirmation = ({ clinic, payload, show, number, complete }) => {

    const getContent = () => {
        return (
            <>
                { payload.service && <div className={ style.summary }>
                    <img src={ payload.service.icon } alt="" />
                    <div>
                        <h1 style={ { margin: 0 } }>
                            { payload.service?.id > 0 ? payload.service.name : '' }
                        </h1>
                        <p style={ { margin: 0 } }>We have successfully booked an appointment for you.</p>
                    </div>
                    <div style={ { marginLeft: 'auto', textAlign: 'right', flex: 'none' } }>
                        <h3 style={ { margin: 0 } }>{ moment(payload.date).format('MMMM DD, YYYY') }</h3>
                        <h3 style={ { margin: 0, fontWeight: 'normal' } }>{ moment(payload.date).format('HH:mm') }</h3>
                    </div>
                </div> }
            </>
        )
    }

    return (
        <StepSkeleton title="Booking Confirmed" number={ number } show={ show } complete={ complete } getContent={ getContent } continueButton={ false } />
    )
}

export default BookingConfirmation;